import React, { useEffect, useMemo, useState } from "react";
import HomeLayout from "../../asset/layout/HomeLayout";
import {
  Box,
  Grid,
  Stack,
  Typography,
  Card,
  CircularProgress,
  IconButton,
  Autocomplete,
  TextField,
  MenuItem,
  FormControlLabel,
  Switch,
  Chip,
  Tooltip,
  alpha,
} from "@mui/material";
import { motion } from "framer-motion";
import CustomButton from "../../components/mui/CustomButton";
import {
  Add,
  SwapVertOutlined as SwapVertOutlinedIcon,
  DragIndicatorOutlined as DragIndicatorOutlinedIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
} from "@mui/icons-material";
import ViewCarouselOutlinedIcon from "@mui/icons-material/ViewCarouselOutlined";
import SmartphoneOutlinedIcon from "@mui/icons-material/SmartphoneOutlined";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import { BannerCard } from "../../components/Cards/BannerCard";
import RModal from "../../components/mui/RModal";
import { enqueueSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import {
  addBanner,
  batchReorderBanners,
  deleteBanner,
  getAllAdminBanner,
  updateBanner,
  updateBannerDisplayOrder,
} from "../../actions/bannerAuth";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useNavigate } from "react-router-dom";
import DropDownMenu from "../../components/mui/DropDownMenu";
import { getAllCategory } from "../../actions/brandsAuth";
const TicketStatus = ["Home Page", "Category Page"];

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.04, duration: 0.45, ease: [0.22, 1, 0.36, 1] },
  }),
};

const PanelCard = ({ children, sx = {} }) => (
  <Card
    elevation={0}
    sx={{
      borderRadius: "24px",
      border: "1px solid",
      borderColor: alpha("#11409B", 0.08),
      bgcolor: "#fff",
      boxShadow: "0 4px 32px rgba(15, 23, 42, 0.06)",
      overflow: "hidden",
      ...sx,
    }}
  >
    {children}
  </Card>
);

const StatCard = ({ icon: Icon, label, value, accent, gradient }) => (
  <PanelCard sx={{ height: "100%" }}>
    <Box sx={{ p: 2.5 }}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "14px",
            background: gradient,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: `0 8px 24px ${alpha(accent, 0.35)}`,
          }}
        >
          <Icon sx={{ color: "#fff", fontSize: 24 }} />
        </Box>
        <Box>
          <Typography
            variant="caption"
            sx={{
              color: "#64748b",
              fontWeight: 600,
              textTransform: "uppercase",
              letterSpacing: "0.06em",
              fontSize: "0.7rem",
            }}
          >
            {label}
          </Typography>
          <Typography
            sx={{
              fontWeight: 800,
              fontSize: "1.75rem",
              color: "#0f172a",
              letterSpacing: "-0.03em",
              lineHeight: 1.1,
            }}
          >
            {value}
          </Typography>
        </Box>
      </Stack>
    </Box>
  </PanelCard>
);

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    bgcolor: "#fff",
    "& fieldset": { borderColor: alpha("#11409B", 0.2) },
    "&:hover fieldset": { borderColor: "#11409B" },
  },
};

const getBannerImage = (banner) =>
  banner?.pictureUrl ||
  banner?.imageUrl ||
  banner?.url ||
  banner?.desktopBannerUrl ||
  banner?.mobileBannerUrl ||
  "";

const getBannerId = (banner) => banner?.id || banner?._id;

export const BannerManagement = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [getBanner, setGetBanner] = useState([]);
  const { user } = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();
  const [bannerId, setBannerId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [countPerPage, setCountPerPage] = useState(10);
  const [allBanner, setAllBanner] = useState(10);
  const [bannerTypeFilter, setBannerTypeFilter] = useState("MOBILE");
  const [bannerActiveFilter, setBannerActiveFilter] = useState(true);
  const [addBannerType, setAddBannerType] = useState("MOBILE");
  const [addBannerActive, setAddBannerActive] = useState(true);
  const [addBannerFile, setAddBannerFile] = useState(null);
  const [addBannerPreview, setAddBannerPreview] = useState("");
  const [addBannerLink, setAddBannerLink] = useState("");
  const [editBannerType, setEditBannerType] = useState("MOBILE");
  const [editBannerActive, setEditBannerActive] = useState(true);
  const [editBannerFile, setEditBannerFile] = useState(null);
  const [editBannerPreview, setEditBannerPreview] = useState("");
  const [editBannerLink, setEditBannerLink] = useState("");
  const [ticketStatusEdit, setTicketStatusEdit] = useState("");
  const [allCategories, setAllCategories] = useState([]);

  const [orderModal, setOrderModal] = useState({
    open: false,
    banner: null,
    displayOrder: 1,
    loading: false,
  });

  const [reorderModal, setReorderModal] = useState({
    open: false,
    banners: [],
    loading: false,
  });

  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);

  const [formData, setFormData] = useState({
    file: null,
    bannerName: "",
    description: "",
    location: "",
    redirectUrl: "",
  });

  const navigate = useNavigate();

  const handleOpenOrderModal = (banner) => {
    const currentOrder = banner?.displayOrder ?? banner?.order ?? 1;
    setOrderModal({
      open: true,
      banner,
      displayOrder: currentOrder,
      loading: false,
    });
  };

  const handleCloseOrderModal = () => {
    setOrderModal({
      open: false,
      banner: null,
      displayOrder: 1,
      loading: false,
    });
  };

  const handleSaveOrder = () => {
    if (!orderModal.banner) return;
    const bannerId = getBannerId(orderModal.banner);
    const newOrder = Number(orderModal.displayOrder);

    if (isNaN(newOrder) || newOrder < 1) {
      enqueueSnackbar("Please enter a valid display order (1 or higher)", {
        variant: "warning",
      });
      return;
    }

    setOrderModal((prev) => ({ ...prev, loading: true }));
    dispatch(
      updateBannerDisplayOrder(
        bannerId,
        newOrder,
        () => {
          setOrderModal({
            open: false,
            banner: null,
            displayOrder: 1,
            loading: false,
          });
          enqueueSnackbar("Banner display order updated successfully", {
            variant: "success",
          });
          getAllBanner();
        },
        (err) => {
          setOrderModal((prev) => ({ ...prev, loading: false }));
          const msg =
            err?.response?.data?.message || "Failed to update banner order";
          enqueueSnackbar(msg, { variant: "error" });
        }
      )
    );
  };

  const handleQuickMove = (banner, direction) => {
    const currentIndex = getBanner.findIndex(
      (b) => getBannerId(b) === getBannerId(banner)
    );
    if (currentIndex === -1) return;
    const targetIndex = currentIndex + direction;
    if (targetIndex < 0 || targetIndex >= getBanner.length) return;

    const reordered = [...getBanner];
    const [moved] = reordered.splice(currentIndex, 1);
    reordered.splice(targetIndex, 0, moved);

    setGetBanner(reordered);

    const batchPayload = reordered.map((b, idx) => ({
      id: getBannerId(b),
      displayOrder: idx + 1,
    }));

    dispatch(
      batchReorderBanners(
        batchPayload,
        () => {
          enqueueSnackbar("Banner order updated", { variant: "success" });
          getAllBanner();
        },
        (err) => {
          getAllBanner();
          const msg =
            err?.response?.data?.message || "Failed to reorder banners";
          enqueueSnackbar(msg, { variant: "error" });
        }
      )
    );
  };

  const handleOpenReorderModal = () => {
    setReorderModal({
      open: true,
      banners: [...getBanner],
      loading: false,
    });
  };

  const handleCloseReorderModal = () => {
    if (!reorderModal.loading) {
      setReorderModal({
        open: false,
        banners: [],
        loading: false,
      });
      setDraggedIndex(null);
      setDragOverIndex(null);
    }
  };

  const handleMoveItem = (index, direction) => {
    const target = index + direction;
    if (target < 0 || target >= reorderModal.banners.length) return;
    const updated = [...reorderModal.banners];
    const [moved] = updated.splice(index, 1);
    updated.splice(target, 0, moved);
    setReorderModal((prev) => ({ ...prev, banners: updated }));
  };

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("text/plain", String(index));
    setDraggedIndex(index);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (dragOverIndex !== index) {
      setDragOverIndex(index);
    }
  };

  const handleDrop = (e, targetIndex) => {
    e.preventDefault();
    const fromIndex = Number(
      e.dataTransfer.getData("text/plain") || draggedIndex
    );
    if (fromIndex !== targetIndex && fromIndex >= 0) {
      const updated = [...reorderModal.banners];
      const [moved] = updated.splice(fromIndex, 1);
      updated.splice(targetIndex, 0, moved);
      setReorderModal((prev) => ({ ...prev, banners: updated }));
    }
    setDraggedIndex(null);
    setDragOverIndex(null);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
    setDragOverIndex(null);
  };

  const handleSaveBatchReorder = () => {
    const batchPayload = reorderModal.banners.map((b, idx) => ({
      id: getBannerId(b),
      displayOrder: idx + 1,
    }));

    setReorderModal((prev) => ({ ...prev, loading: true }));
    dispatch(
      batchReorderBanners(
        batchPayload,
        () => {
          setReorderModal({ open: false, banners: [], loading: false });
          enqueueSnackbar("All banners reordered successfully", {
            variant: "success",
          });
          getAllBanner();
        },
        (err) => {
          setReorderModal((prev) => ({ ...prev, loading: false }));
          const msg =
            err?.response?.data?.message || "Failed to reorder banners";
          enqueueSnackbar(msg, { variant: "error" });
        }
      )
    );
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    console.log("User ID:", user);
  }, [user]);

  const userId = user.id;

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setFormData({
      file: null,
      bannerName: "",
      description: "",
      location: "",
      redirectUrl: "",
    });
    setAddBannerType("MOBILE");
    setAddBannerActive(true);
    setAddBannerFile(null);
    setAddBannerPreview("");
    setAddBannerLink("");
  };

  const openEditModal = (banner) => {
    setIsEditModalOpen(true);
    setBannerId(getBannerId(banner));
    setEditBannerType(banner?.type || bannerTypeFilter || "MOBILE");
    setEditBannerActive(banner?.active !== false);
    setEditBannerLink(banner?.link || banner?.redirectUrl || "");
    setEditBannerFile(null);
    setEditBannerPreview(getBannerImage(banner));
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setEditBannerType("MOBILE");
    setEditBannerActive(true);
    setEditBannerFile(null);
    setEditBannerPreview("");
    setEditBannerLink("");
  };

  const getAllBanner = () => {
    setLoading(true);
    dispatch(
      getAllAdminBanner(
        {
          page: Math.max(currentPage - 1, 0),
          size: Number(countPerPage),
          type: bannerTypeFilter,
          active: bannerActiveFilter,
        },
        userId,
        (data) => {
          const bannerContent =
            data?.data?.content ||
            data?.data?.data?.content ||
            data?.data?.data?.banners ||
            [];
          const sortedContent = Array.isArray(bannerContent)
            ? [...bannerContent].sort(
                (a, b) =>
                  (a?.displayOrder ?? a?.order ?? 9999) -
                  (b?.displayOrder ?? b?.order ?? 9999)
              )
            : [];
          setGetBanner(sortedContent);
          setAllBanner(data?.data?.totalElements ?? bannerContent?.length ?? 0);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
          console.log(err);
        }
      )
    );
  };

  useEffect(() => {
    setLoading(true);
    getAllBanner();
  }, [dispatch, countPerPage, currentPage, bannerTypeFilter, bannerActiveFilter]);

  // const handleFileChange = (e, isEdit = false) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       if (isEdit) {
  //         setUploadedImage(reader.result);
  //         setEditFormData((prevState) => ({
  //           ...prevState,
  //           file,
  //         }));
  //       } else {
  //         setUploadedImage(reader.result);
  //         setFormData((prevState) => ({
  //           ...prevState,
  //           file,
  //         }));
  //       }
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };
  const handleDataChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    if (!addBannerFile) {
      enqueueSnackbar("Please upload a banner file", {
        variant: "error",
      });
      setLoading(false);
      return;
    }

    const payload = {
      file: addBannerFile,
      type: addBannerType,
      active: addBannerActive,
      link: addBannerLink,
    };
    dispatch(
      addBanner(
        userId,
        payload,
        (Response) => {
          enqueueSnackbar("Data submitted successfully", {
            variant: "success",
          });
          console.log("The response of the post request is", Response);
          setLoading(false);
          closeModal();
          getAllBanner();
        },
        (error) => {
          enqueueSnackbar("An error occurred", {
            variant: "error",
          });
          setLoading(false);
        }
      )
    );
  };

  const editHandleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    if (!bannerId) {
      enqueueSnackbar("Invalid banner ID", { variant: "error" });
      setLoading(false);
      return;
    }

    if (!editBannerFile) {
      enqueueSnackbar("Please upload a banner file", { variant: "error" });
      setLoading(false);
      return;
    }

    const payload = {
      file: editBannerFile,
      type: editBannerType,
      active: editBannerActive,
      link: editBannerLink,
    };

    dispatch(
      updateBanner(
        bannerId,
        payload,
        () => {
          enqueueSnackbar("Banner updated successfully", { variant: "success" });
          setLoading(false);
          closeEditModal();
          getAllBanner();
        },
        (error) => {
          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            "Failed to update banner";
          enqueueSnackbar(errorMessage, { variant: "error" });
          setLoading(false);
        }
      )
    );
  };
  useEffect(() => {
    dispatch(
      getAllCategory(
        (data) => {
          console.log(data);
          setAllCategories(data.data.data.categories);
          console.log("data.data.data.categories", data.data.data.categories);
        },
        (err) => {
          console.log(err);
        }
      )
    );
  }, []);
  const handleDelete = (id) => {
    if (!id) {
      enqueueSnackbar("Invalid banner ID", { variant: "error" });
      return;
    }

    dispatch(
      deleteBanner(
        id,
        {},
        (Response) => {
          enqueueSnackbar("Banner deleted successfully", {
            variant: "success",
          });
          console.log("The response of the post request is", Response);
          setLoading(false);
          getAllBanner();
        },
        (error) => {
          enqueueSnackbar("An error occurred", {
            variant: "error",
          });
          setLoading(false);
        }
      )
    );
  };

  const [secondaryOptions, setSecondaryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleCategoryChange = (categoryLabel) => {
    console.log("Selected Category:", categoryLabel);
    setSelectedCategory(categoryLabel);
  };

  const renderFormFields = () => {
    if (selectedCategory === "Home Page") {
      return (
        <>
          <Grid item xs={12} sm={12}>
            <Typography variant="h5" mb={2} mt={1}>
              Select Home Banner
            </Typography>
            <DropDownMenu
              buttonText="Home Page Location"
              menuItems={[
                { label: "Top" },
                { label: "Below Category" },
                { label: "Below New Arrivals" },
              ]}
              selectedItem={formData.location}
              setSelectedItem={(label) => handleDataChange("location", label)}
              buttonWidth={"100%"}
            />
          </Grid>
        </>
      );
    } else if (selectedCategory === "Category Page") {
      return (
        <Grid item xs={12} sm={12}>
          <Typography variant="h5" mb={2} mt={1}>
            Select Category
          </Typography>
          <Autocomplete
            id="combo-box-demo"
            value={formData.category}
            onChange={(event, newValue) => {
              handleDataChange("category", newValue);
            }}
            options={allCategories}
            getOptionLabel={(option) => option.CategoryName}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Category"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>
      );
    } else {
      return null;
    }
  };

  const totalPages = Math.ceil(allBanner / countPerPage) || 1;

  const stats = useMemo(() => {
    const active = getBanner.filter((b) => b.active !== false).length;
    return {
      total: allBanner,
      onPage: getBanner.length,
      active,
      inactive: getBanner.length - active,
    };
  }, [getBanner, allBanner]);

  const premiumButtonSx = {
    height: "44px",
    borderRadius: "12px",
    fontWeight: 600,
    textTransform: "none",
    background: "linear-gradient(135deg, #11409B 0%, #2563eb 100%)",
    boxShadow: "0 6px 24px rgba(37, 99, 235, 0.35)",
    "&:hover": {
      background: "linear-gradient(135deg, #0f3580 0%, #1d4ed8 100%)",
    },
  };

  return (
    <HomeLayout>
      <Box
        sx={{
          minHeight: "100%",
          background:
            "linear-gradient(180deg, #f0f4fa 0%, #f5f7fa 35%, #eef2f7 100%)",
          mx: -3,
          mt: -3,
          px: 3,
          pt: 3,
          pb: 4,
        }}
      >
        <motion.div initial="hidden" animate="visible" variants={fadeUp}>
          <Box
            sx={{
              p: { xs: 3, md: 4 },
              mb: 3,
              borderRadius: "24px",
              background:
                "linear-gradient(135deg, #0c3483 0%, #11409B 40%, #1e40af 70%, #2563eb 100%)",
              color: "#fff",
              position: "relative",
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(17, 64, 155, 0.35)",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: -50,
                right: -30,
                width: 200,
                height: 200,
                borderRadius: "50%",
                bgcolor: alpha("#fff", 0.06),
              }}
            />
            <Stack
              direction={{ xs: "column", sm: "row" }}
              alignItems={{ xs: "flex-start", sm: "center" }}
              justifyContent="space-between"
              spacing={2}
              sx={{ position: "relative", zIndex: 1 }}
            >
              <Box>
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                  <ViewCarouselOutlinedIcon />
                  <Typography
                    variant="caption"
                    sx={{ fontWeight: 600, letterSpacing: "0.1em", opacity: 0.85 }}
                  >
                    MARKETING
                  </Typography>
                </Stack>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 800, letterSpacing: "-0.03em" }}
                >
                  Banner management
                </Typography>
                <Typography sx={{ mt: 1, opacity: 0.82, maxWidth: 520 }}>
                  Upload and manage mobile and desktop banners. Filter by type
                  and status, then edit or remove creatives from the grid.
                </Typography>
              </Box>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={1.5}
                alignItems={{ xs: "stretch", sm: "center" }}
              >
                <CustomButton
                  onClick={handleOpenReorderModal}
                  variant="outlined"
                  startIcon={<SwapVertOutlinedIcon />}
                  sx={{
                    ...premiumButtonSx,
                    bgcolor: alpha("#fff", 0.12),
                    color: "#fff",
                    border: `1px solid ${alpha("#fff", 0.35)}`,
                    boxShadow: "none",
                    "&:hover": {
                      bgcolor: alpha("#fff", 0.22),
                      borderColor: alpha("#fff", 0.6),
                    },
                  }}
                >
                  Reorder Banners
                </CustomButton>
                <CustomButton
                  onClick={openModal}
                  variant="contained"
                  startIcon={<Add />}
                  sx={{
                    ...premiumButtonSx,
                    bgcolor: alpha("#fff", 0.15),
                    backdropFilter: "blur(8px)",
                    border: `1px solid ${alpha("#fff", 0.25)}`,
                    boxShadow: "none",
                    "&:hover": { bgcolor: alpha("#fff", 0.22) },
                  }}
                >
                  {loading ? (
                    <CircularProgress size={22} sx={{ color: "#fff" }} />
                  ) : (
                    "Add banner"
                  )}
                </CustomButton>
              </Stack>
            </Stack>
          </Box>
        </motion.div>

        <Grid container spacing={2.5} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6} md={3}>
            <motion.div custom={0} initial="hidden" animate="visible" variants={fadeUp}>
              <StatCard
                icon={ViewCarouselOutlinedIcon}
                label="Total banners"
                value={stats.total}
                accent="#4f46e5"
                gradient="linear-gradient(135deg, #818cf8 0%, #4f46e5 100%)"
              />
            </motion.div>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <motion.div custom={1} initial="hidden" animate="visible" variants={fadeUp}>
              <StatCard
                icon={
                  bannerTypeFilter === "MOBILE"
                    ? SmartphoneOutlinedIcon
                    : DesktopWindowsOutlinedIcon
                }
                label={`${bannerTypeFilter} view`}
                value={stats.onPage}
                accent="#2563eb"
                gradient="linear-gradient(135deg, #60a5fa 0%, #2563eb 100%)"
              />
            </motion.div>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <motion.div custom={2} initial="hidden" animate="visible" variants={fadeUp}>
              <StatCard
                icon={CheckCircleOutlineOutlinedIcon}
                label="Active (page)"
                value={stats.active}
                accent="#059669"
                gradient="linear-gradient(135deg, #34d399 0%, #059669 100%)"
              />
            </motion.div>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <motion.div custom={3} initial="hidden" animate="visible" variants={fadeUp}>
              <StatCard
                icon={ViewCarouselOutlinedIcon}
                label="Inactive (page)"
                value={stats.inactive}
                accent="#64748b"
                gradient="linear-gradient(135deg, #94a3b8 0%, #64748b 100%)"
              />
            </motion.div>
          </Grid>
        </Grid>

        <motion.div custom={4} initial="hidden" animate="visible" variants={fadeUp}>
          <PanelCard sx={{ mb: 3, p: { xs: 2, md: 2.5 } }}>
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <FilterListOutlinedIcon sx={{ color: "#11409B", fontSize: 20 }} />
              <Typography sx={{ fontWeight: 700, color: "#0f172a" }}>
                Filters
              </Typography>
              <Chip
                label={bannerActiveFilter ? "Showing active" : "Showing inactive"}
                size="small"
                sx={{
                  ml: 1,
                  bgcolor: bannerActiveFilter
                    ? alpha("#16a34a", 0.12)
                    : alpha("#64748b", 0.12),
                  color: bannerActiveFilter ? "#16a34a" : "#64748b",
                  fontWeight: 700,
                  fontSize: "0.7rem",
                }}
              />
            </Stack>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <TextField
                  select
                  fullWidth
                  label="Banner type"
                  value={bannerTypeFilter}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setBannerTypeFilter(e.target.value);
                  }}
                  sx={fieldSx}
                >
                  <MenuItem value="MOBILE">Mobile</MenuItem>
                  <MenuItem value="DESKTOP">Desktop</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={4}>
                <PanelCard
                  sx={{
                    p: 1.5,
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "none",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={bannerActiveFilter}
                        onChange={(e) => {
                          setCurrentPage(1);
                          setBannerActiveFilter(e.target.checked);
                        }}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#11409B",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            { bgcolor: alpha("#11409B", 0.5) },
                        }}
                      />
                    }
                    label={
                      <Typography sx={{ fontWeight: 600, color: "#0f172a" }}>
                        {bannerActiveFilter ? "Active only" : "Inactive only"}
                      </Typography>
                    }
                  />
                </PanelCard>
              </Grid>
            </Grid>
          </PanelCard>
        </motion.div>

        <motion.div custom={5} initial="hidden" animate="visible" variants={fadeUp}>
          {loading ? (
            <PanelCard>
              <Stack alignItems="center" justifyContent="center" sx={{ py: 10 }}>
                <CircularProgress sx={{ color: "#11409B" }} />
                <Typography sx={{ mt: 2, color: "#64748b" }}>
                  Loading banners…
                </Typography>
              </Stack>
            </PanelCard>
          ) : getBanner.length > 0 ? (
            <Grid container spacing={2.5}>
              {getBanner.map((banner, index) => (
                <Grid
                  item
                  key={getBannerId(banner) || index}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  xl={2.4}
                >
                  <BannerCard
                    username={banner?.bannerName}
                    image={getBannerImage(banner)}
                    dis={banner?.description}
                    type={banner?.type || bannerTypeFilter}
                    active={banner?.active}
                    order={banner?.displayOrder ?? banner?.order ?? (index + 1)}
                    onChangeOrder={() => handleOpenOrderModal(banner)}
                    onMoveUp={() => handleQuickMove(banner, -1)}
                    onMoveDown={() => handleQuickMove(banner, 1)}
                    isFirst={index === 0}
                    isLast={index === getBanner.length - 1}
                    onEdit={() => openEditModal(banner)}
                    onDelete={() => handleDelete(getBannerId(banner))}
                  />
                </Grid>
              ))}
            </Grid>
          ) : (
            <PanelCard>
              <Stack alignItems="center" sx={{ py: 8, px: 3 }}>
                <ViewCarouselOutlinedIcon
                  sx={{ fontSize: 56, color: "#cbd5e1", mb: 2 }}
                />
                <Typography variant="h6" sx={{ fontWeight: 700, color: "#0f172a" }}>
                  No banners found
                </Typography>
                <Typography sx={{ color: "#64748b", mt: 1, textAlign: "center" }}>
                  Try changing the type or status filter, or add a new banner.
                </Typography>
                <CustomButton
                  onClick={openModal}
                  variant="contained"
                  startIcon={<Add />}
                  sx={{ ...premiumButtonSx, mt: 3 }}
                >
                  Add banner
                </CustomButton>
              </Stack>
            </PanelCard>
          )}
        </motion.div>

        {!loading && allBanner > 0 && (
          <motion.div custom={6} initial="hidden" animate="visible" variants={fadeUp}>
            <PanelCard sx={{ mt: 3, p: 2 }}>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                alignItems="center"
                justifyContent="space-between"
                spacing={2}
              >
                <Typography sx={{ color: "#64748b", fontWeight: 500 }}>
                  Showing {(currentPage - 1) * countPerPage + 1}–
                  {Math.min(currentPage * countPerPage, allBanner)} of {allBanner}
                </Typography>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Typography variant="body2" sx={{ color: "#64748b" }}>
                    Rows per page
                  </Typography>
                  <Box
                    component="select"
                    value={countPerPage}
                    onChange={(e) => {
                      setCountPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                    sx={{
                      border: `1px solid ${alpha("#11409B", 0.2)}`,
                      borderRadius: "10px",
                      px: 1.5,
                      py: 0.75,
                      fontSize: "0.875rem",
                      color: "#0f172a",
                      bgcolor: "#fff",
                      outline: "none",
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                  </Box>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <IconButton
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                      disabled={currentPage === 1}
                      sx={{
                        border: "1px solid",
                        borderColor: alpha("#11409B", 0.15),
                        borderRadius: "12px",
                        bgcolor: "#fff",
                        "&:hover": { bgcolor: alpha("#11409B", 0.06) },
                      }}
                    >
                      <KeyboardArrowLeftIcon />
                    </IconButton>
                    <Typography sx={{ fontWeight: 600, minWidth: 48, textAlign: "center" }}>
                      {currentPage} / {totalPages}
                    </Typography>
                    <IconButton
                      onClick={() =>
                        setCurrentPage((p) => Math.min(p + 1, totalPages))
                      }
                      disabled={currentPage >= totalPages}
                      sx={{
                        border: "1px solid",
                        borderColor: alpha("#11409B", 0.15),
                        borderRadius: "12px",
                        bgcolor: "#fff",
                        "&:hover": { bgcolor: alpha("#11409B", 0.06) },
                      }}
                    >
                      <KeyboardArrowRightIcon />
                    </IconButton>
                  </Stack>
                </Stack>
              </Stack>
            </PanelCard>
          </motion.div>
        )}
      </Box>

      <RModal
        open={isModalOpen}
        handleClose={closeModal}
        width={"80%"}
        height={{ xl: "80%", md: "80%", sm: "80%", xs: "80%" }}
      >
        <Box>
          <Typography variant="h6" gutterBottom>
            Add New Banner
          </Typography>
          <form onSubmit={handleSubmit} style={{}}>
            <Grid container spacing={2} mb={2}>
              <Grid item md={6} xs={12}>
                <TextField
                  select
                  fullWidth
                  label="Type"
                  value={addBannerType}
                  onChange={(e) => setAddBannerType(e.target.value)}
                >
                  <MenuItem value="MOBILE">MOBILE</MenuItem>
                  <MenuItem value="DESKTOP">DESKTOP</MenuItem>
                </TextField>
              </Grid>
              <Grid item md={6} xs={12}>
                <FormControlLabel
                  sx={{ mt: 1 }}
                  control={
                    <Switch
                      checked={addBannerActive}
                      onChange={(e) => setAddBannerActive(e.target.checked)}
                    />
                  }
                  label={addBannerActive ? "Active" : "Inactive"}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Link"
                  placeholder="https://..."
                  value={addBannerLink}
                  onChange={(e) => setAddBannerLink(e.target.value)}
                  sx={fieldSx}
                />
              </Grid>
            </Grid>

            <Stack direction={"row"} spacing={2}>
              <input
                accept="image/*"
                type="file"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (!file) return;
                  setAddBannerFile(file);
                  setAddBannerPreview(URL.createObjectURL(file));
                }}
                id="add-banner-file"
                style={{
                  display: "none",
                  width: "20%",
                }}
              />
              <Box sx={{ width: "8.5rem", textAlign: "center" }}>
                {" "}
                <label htmlFor="add-banner-file">
                  {addBannerPreview ? (
                    <Card
                      sx={{
                        borderRadius: "1.25rem",
                        height: "8rem",
                        width: "8rem",
                        boxShadow: "none",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        bgcolor: "rgba(237, 242, 246, 1)",
                        mt: 2,
                        cursor: "pointer",
                      }}
                      style={{
                        border: "1px solid red !important",
                      }}
                    >
                      <img
                        src={addBannerPreview}
                        alt="Preview"
                        style={{
                          width: "100%",
                          maxHeight: "200px",
                        }}
                      />
                    </Card>
                  ) : (
                    <Box
                      sx={{
                        width: "8rem",
                      }}
                    >
                      {" "}
                      <Card
                        sx={{
                          borderRadius: "1.25rem",
                          height: "8rem",
                          width: "8rem",
                          boxShadow: "none",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          bgcolor: "rgba(237, 242, 246, 1)",
                          mt: 2,
                          cursor: "pointer",
                        }}
                      >
                        {" "}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img alt="Banner" src="/addimgcard.svg" />
                        </Box>
                        <Typography
                          mx={1}
                          textAlign={"center"}
                          variant="p"
                          sx={{
                            fontSize: ".9rem",
                          }}
                        >
                          Upload banner file
                        </Typography>
                      </Card>
                    </Box>
                  )}
                </label>
                <Typography variant="p" sx={{ mt: 2, textAlign: "center" }}>
                  Selected Banner File
                </Typography>
              </Box>
            </Stack>

            <Box mt={2}>
              <CustomButton
                type="submit"
                variant="contained"
                fullWidth
                width={"9rem"}
              >
                {loading ? (
                  <CircularProgress size={24} sx={{ color: "#FFFFFF" }} />
                ) : (
                  "Submit"
                )}
              </CustomButton>
            </Box>
          </form>
        </Box>
      </RModal>

      <RModal
        open={isEditModalOpen}
        handleClose={closeEditModal}
        width={"80%"}
        height={{ xl: "80%", md: "80%", sm: "80%", xs: "80%" }}
      >
        <Box>
          <Typography variant="h6" gutterBottom>
            Update banner
          </Typography>
          <Typography mt={0.5} variant="body2" sx={{ color: "#64748b", mb: 2 }}>
            Upload a new image file. Type, active status, and link are sent as
            query parameters.
          </Typography>
          <form onSubmit={editHandleSubmit}>
            <Grid container spacing={2} mb={2}>
              <Grid item md={6} xs={12}>
                <TextField
                  select
                  fullWidth
                  label="Type"
                  value={editBannerType}
                  onChange={(e) => setEditBannerType(e.target.value)}
                  sx={fieldSx}
                >
                  <MenuItem value="MOBILE">MOBILE</MenuItem>
                  <MenuItem value="DESKTOP">DESKTOP</MenuItem>
                </TextField>
              </Grid>
              <Grid item md={6} xs={12}>
                <FormControlLabel
                  sx={{ mt: 1 }}
                  control={
                    <Switch
                      checked={editBannerActive}
                      onChange={(e) => setEditBannerActive(e.target.checked)}
                    />
                  }
                  label={editBannerActive ? "Active" : "Inactive"}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Link"
                  placeholder="https://..."
                  value={editBannerLink}
                  onChange={(e) => setEditBannerLink(e.target.value)}
                  sx={fieldSx}
                />
              </Grid>
            </Grid>

            <Stack direction="row" spacing={2}>
              <input
                accept="image/*"
                type="file"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (!file) return;
                  setEditBannerFile(file);
                  setEditBannerPreview(URL.createObjectURL(file));
                }}
                id="edit-banner-file"
                style={{ display: "none" }}
              />
              <Box sx={{ width: "8.5rem", textAlign: "center" }}>
                <label htmlFor="edit-banner-file">
                  {editBannerPreview ? (
                    <Card
                      sx={{
                        borderRadius: "1.25rem",
                        height: "8rem",
                        width: "8rem",
                        boxShadow: "none",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        bgcolor: "rgba(237, 242, 246, 1)",
                        mt: 2,
                        cursor: "pointer",
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        component="img"
                        src={editBannerPreview}
                        alt="Preview"
                        sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                    </Card>
                  ) : (
                    <Card
                      sx={{
                        borderRadius: "1.25rem",
                        height: "8rem",
                        width: "8rem",
                        boxShadow: "none",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        bgcolor: "rgba(237, 242, 246, 1)",
                        mt: 2,
                        cursor: "pointer",
                      }}
                    >
                      <img alt="Banner" src="/addimgcard.svg" />
                      <Typography
                        mx={1}
                        textAlign="center"
                        variant="body2"
                        sx={{ fontSize: ".9rem" }}
                      >
                        Upload banner file
                      </Typography>
                    </Card>
                  )}
                </label>
                <Typography variant="body2" sx={{ mt: 2, textAlign: "center" }}>
                  Banner file (required)
                </Typography>
              </Box>
            </Stack>

            <Box mt={2}>
              <CustomButton
                type="submit"
                variant="contained"
                fullWidth
                width={"9rem"}
              >
                {loading ? (
                  <CircularProgress size={24} sx={{ color: "#FFFFFF" }} />
                ) : (
                  "Update"
                )}
              </CustomButton>
            </Box>
          </form>
        </Box>
      </RModal>

      {/* Single Banner Order Modal */}
      <RModal
        open={orderModal.open}
        handleClose={handleCloseOrderModal}
        width={460}
      >
        <Box sx={{ pt: 1 }}>
          <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "12px",
                bgcolor: alpha("#11409B", 0.1),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#11409B",
              }}
            >
              <SwapVertOutlinedIcon />
            </Box>
            <Box>
              <Typography
                variant="h6"
                sx={{ fontWeight: 800, color: "#0f172a", lineHeight: 1.2 }}
              >
                Change Display Order
              </Typography>
              <Typography variant="caption" sx={{ color: "#64748b" }}>
                Update banner placement sequence
              </Typography>
            </Box>
          </Stack>

          {orderModal.banner && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 1.5,
                mb: 3,
                borderRadius: "14px",
                bgcolor: alpha("#11409B", 0.04),
                border: `1px solid ${alpha("#11409B", 0.1)}`,
              }}
            >
              {getBannerImage(orderModal.banner) ? (
                <Box
                  component="img"
                  src={getBannerImage(orderModal.banner)}
                  alt="Banner"
                  sx={{
                    width: 64,
                    height: 44,
                    borderRadius: "8px",
                    objectFit: "cover",
                    flexShrink: 0,
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: 64,
                    height: 44,
                    borderRadius: "8px",
                    bgcolor: alpha("#11409B", 0.1),
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "0.75rem",
                    color: "#64748b",
                    flexShrink: 0,
                  }}
                >
                  No img
                </Box>
              )}
              <Box sx={{ overflow: "hidden", flex: 1 }}>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "0.9rem",
                    color: "#0f172a",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {orderModal.banner?.bannerName || "Banner"}
                </Typography>
                <Stack direction="row" spacing={1} mt={0.5}>
                  <Chip
                    label={orderModal.banner?.type || bannerTypeFilter}
                    size="small"
                    sx={{ height: 20, fontSize: "0.65rem", fontWeight: 700 }}
                  />
                  <Chip
                    label={`Current #${
                      orderModal.banner?.displayOrder ??
                      orderModal.banner?.order ??
                      "-"
                    }`}
                    size="small"
                    sx={{
                      height: 20,
                      fontSize: "0.65rem",
                      fontWeight: 700,
                      bgcolor: alpha("#11409B", 0.1),
                      color: "#11409B",
                    }}
                  />
                </Stack>
              </Box>
            </Box>
          )}

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "0.85rem",
              color: "#334155",
              mb: 1,
            }}
          >
            New Display Order (1 or higher)
          </Typography>
          <TextField
            fullWidth
            type="number"
            inputProps={{ min: 1, step: 1 }}
            value={orderModal.displayOrder}
            onChange={(e) =>
              setOrderModal((prev) => ({
                ...prev,
                displayOrder: e.target.value,
              }))
            }
            placeholder="e.g. 1"
            helperText="Lower numbers appear first (e.g. 1 is shown at the top / front of the carousel)."
            sx={fieldSx}
          />

          <Stack
            direction="row"
            spacing={1.5}
            justifyContent="flex-end"
            sx={{ mt: 3 }}
          >
            <CustomButton
              variant="outlined"
              onClick={handleCloseOrderModal}
              disabled={orderModal.loading}
              sx={{
                borderRadius: "12px",
                borderColor: alpha("#11409B", 0.25),
                color: "#475569",
              }}
            >
              Cancel
            </CustomButton>
            <CustomButton
              variant="contained"
              onClick={handleSaveOrder}
              disabled={orderModal.loading}
              sx={premiumButtonSx}
            >
              {orderModal.loading ? (
                <CircularProgress size={20} sx={{ color: "#fff" }} />
              ) : (
                "Save Order"
              )}
            </CustomButton>
          </Stack>
        </Box>
      </RModal>

      {/* Batch Reorder Banners Modal */}
      <RModal
        open={reorderModal.open}
        handleClose={handleCloseReorderModal}
        width={680}
      >
        <Box sx={{ pt: 1 }}>
          <Stack direction="row" alignItems="center" spacing={1.5} mb={1}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "12px",
                bgcolor: alpha("#11409B", 0.1),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#11409B",
              }}
            >
              <SwapVertOutlinedIcon />
            </Box>
            <Box>
              <Typography
                variant="h6"
                sx={{ fontWeight: 800, color: "#0f172a", lineHeight: 1.2 }}
              >
                Batch Reorder Banners
              </Typography>
              <Typography variant="caption" sx={{ color: "#64748b" }}>
                Drag and drop rows or use arrow buttons to arrange priority order
              </Typography>
            </Box>
          </Stack>

          <Typography variant="body2" sx={{ color: "#64748b", mb: 2 }}>
            The banner at the top (#1) will be displayed first in the app. Click
            "Save Order" to persist changes.
          </Typography>

          <Box
            sx={{
              maxHeight: "55vh",
              overflowY: "auto",
              pr: 0.5,
              display: "flex",
              flexDirection: "column",
              gap: 1.2,
            }}
          >
            {reorderModal.banners.map((b, index) => {
              const isDragging = draggedIndex === index;
              const isOver = dragOverIndex === index;
              const bImg = getBannerImage(b);

              return (
                <Box
                  key={getBannerId(b) || index}
                  draggable
                  onDragStart={(e) => handleDragStart(e, index)}
                  onDragOver={(e) => handleDragOver(e, index)}
                  onDrop={(e) => handleDrop(e, index)}
                  onDragEnd={handleDragEnd}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    p: 1.2,
                    borderRadius: "14px",
                    bgcolor: isOver ? alpha("#11409B", 0.08) : "#fff",
                    border: "1.5px solid",
                    borderColor: isOver
                      ? "#11409B"
                      : isDragging
                      ? alpha("#11409B", 0.4)
                      : alpha("#11409B", 0.12),
                    opacity: isDragging ? 0.45 : 1,
                    transition: "all 0.15s ease",
                    cursor: "grab",
                    "&:active": { cursor: "grabbing" },
                    "&:hover": {
                      borderColor: "#11409B",
                      boxShadow: "0 2px 8px rgba(17, 64, 155, 0.08)",
                    },
                  }}
                >
                  <Tooltip title="Drag to reorder">
                    <Box
                      sx={{
                        color: "#94a3b8",
                        display: "flex",
                        alignItems: "center",
                        cursor: "grab",
                      }}
                    >
                      <DragIndicatorOutlinedIcon />
                    </Box>
                  </Tooltip>

                  <Chip
                    label={`#${index + 1}`}
                    size="small"
                    sx={{
                      fontWeight: 800,
                      minWidth: 44,
                      bgcolor: index === 0 ? "#11409B" : alpha("#11409B", 0.1),
                      color: index === 0 ? "#fff" : "#11409B",
                    }}
                  />

                  {bImg ? (
                    <Box
                      component="img"
                      src={bImg}
                      alt="Banner"
                      sx={{
                        width: 56,
                        height: 38,
                        borderRadius: "8px",
                        objectFit: "cover",
                        flexShrink: 0,
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: 56,
                        height: 38,
                        borderRadius: "8px",
                        bgcolor: alpha("#11409B", 0.06),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "0.7rem",
                        color: "#64748b",
                        flexShrink: 0,
                      }}
                    >
                      No img
                    </Box>
                  )}

                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "0.875rem",
                        color: "#0f172a",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {b.bannerName || "Untitled Banner"}
                    </Typography>
                    <Stack direction="row" spacing={0.8} mt={0.3}>
                      {b.type && (
                        <Chip
                          label={b.type}
                          size="small"
                          sx={{
                            height: 18,
                            fontSize: "0.62rem",
                            fontWeight: 600,
                          }}
                        />
                      )}
                      <Chip
                        label={b.active !== false ? "Active" : "Inactive"}
                        size="small"
                        sx={{
                          height: 18,
                          fontSize: "0.62rem",
                          fontWeight: 600,
                          color: b.active !== false ? "#16a34a" : "#64748b",
                          bgcolor: alpha(
                            b.active !== false ? "#16a34a" : "#64748b",
                            0.1
                          ),
                        }}
                      />
                    </Stack>
                  </Box>

                  <Stack direction="row" spacing={0.5}>
                    <Tooltip title="Move Up">
                      <span>
                        <IconButton
                          size="small"
                          disabled={index === 0}
                          onClick={() => handleMoveItem(index, -1)}
                          sx={{
                            border: `1px solid ${alpha("#11409B", 0.15)}`,
                            borderRadius: "8px",
                            p: 0.6,
                            "&:hover": { bgcolor: alpha("#11409B", 0.08) },
                          }}
                        >
                          <KeyboardArrowUpIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Move Down">
                      <span>
                        <IconButton
                          size="small"
                          disabled={index === reorderModal.banners.length - 1}
                          onClick={() => handleMoveItem(index, 1)}
                          sx={{
                            border: `1px solid ${alpha("#11409B", 0.15)}`,
                            borderRadius: "8px",
                            p: 0.6,
                            "&:hover": { bgcolor: alpha("#11409B", 0.08) },
                          }}
                        >
                          <KeyboardArrowDownIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Stack>
                </Box>
              );
            })}
          </Box>

          <Stack
            direction="row"
            spacing={1.5}
            justifyContent="flex-end"
            sx={{
              mt: 3,
              pt: 1,
              borderTop: `1px solid ${alpha("#11409B", 0.08)}`,
            }}
          >
            <CustomButton
              variant="outlined"
              onClick={handleCloseReorderModal}
              disabled={reorderModal.loading}
              sx={{
                borderRadius: "12px",
                borderColor: alpha("#11409B", 0.25),
                color: "#475569",
              }}
            >
              Cancel
            </CustomButton>
            <CustomButton
              variant="contained"
              onClick={handleSaveBatchReorder}
              disabled={
                reorderModal.loading || reorderModal.banners.length === 0
              }
              sx={premiumButtonSx}
            >
              {reorderModal.loading ? (
                <CircularProgress size={20} sx={{ color: "#fff" }} />
              ) : (
                "Save Order"
              )}
            </CustomButton>
          </Stack>
        </Box>
      </RModal>
    </HomeLayout>
  );
};
